<template>
  <div class="flex flex-col justify-center items-center">
    <div
      class="text-center text-2xl md:text-4xl flex-1 w-full max-w-2xl lg:max-w-4xl mb-10 prose prose-lg"
      v-html="htmlText"
    ></div>
    <div class="flex-1 mb-10">
      <img
        v-bind="disalbeCopy"
        :src="content.image"
        class="w-full my-0 mx-auto max-w-2xl"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { IContent } from '@/store/modules/common/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import showdown from 'showdown';

@Component
export default class ImageSlide extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: IContent;

  get htmlText(): string {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(this.content.text);
  }

  get disalbeCopy() {
    if (this.$store.state.common.disalbeCopy) {
      return {
        style:
          'user-select: none;-webkit-user-drag: none;-webkit-user-select: none;-webkit-touch-callout: none;',
        oncontextmenu: 'return false;'
      };
    }
    return {};
  }
}
</script>
